module.exports = __webpack_public_path__ + "img/中国环境监测总站.9e4e015e.png";